import React from "react"

import { cn } from "@/lib/utils"

type TCardNewsSkeletonProps = {
  className?: string
}

const CardNewsSkeleton = ({ className }: TCardNewsSkeletonProps) => {
  return (
    <article
      className={cn(
        "flex h-full max-w-[343px] flex-col items-stretch sm:max-w-[360px] lg:max-w-[490px]",
        className
      )}
    >
      <div className="aspect-[3/2] animate-pulse bg-neutral-300 lg:aspect-[4/3]"></div>
      <div className="h-full px-5 lg:px-6">
        <div
          className={cn(
            "card flex h-full -translate-y-9 flex-col justify-between"
          )}
        >
          <div className="animate-pulse">
            <header className="pb-5">
              <div className="my-5 h-[2rem] w-[15rem] rounded-100 bg-neutral-300 lg:w-[20rem] " />
              <div className="mb-2 h-[1rem] w-[10rem] rounded-100 bg-neutral-300 " />
            </header>
            <div className="grid grid-cols-3 gap-4">
              <div className="col-span-2 h-[1.5rem] rounded-100 bg-neutral-300" />
              <div className="col-span-1 h-[1.5rem] rounded-100 bg-neutral-300" />
            </div>
          </div>

          <footer className="grid grid-cols-3 gap-4 pt-5">
            <div className="col-end-4 mb-2 h-[1rem] rounded-100 bg-neutral-300 " />
          </footer>
        </div>
      </div>
    </article>
  )
}

export { CardNewsSkeleton, type TCardNewsSkeletonProps }
